<div class="mobile__container-full-screen">
    <app-mobile-nav></app-mobile-nav>
    <div class="mobile__container">
        <router-outlet></router-outlet>
    </div>
    <div class="mobile__footer">
        <app-mobile-footer></app-mobile-footer>
    </div>
</div>
